// 本模块为首页视图相关逻辑及状态,主要用来做页面传参
import index from "@/api/index.js";

const state = {
  // 轮播图数据
  indexSwipers: [],
  wapSwipers: [],
  // 沃沃农贸
  vvLife: [
    {
      image: require("@/assets/images/index/vv_life_icon_1.png"),
      image_show: require("@/assets/images/index/vv_life_icon_1_show.png"),
      title: "沃沃农批",
      sub_title: "新型智慧农产品批发对接平台"
    },
    {
      image: require("@/assets/images/index/vv_life_icon_2.png"),
      image_show: require("@/assets/images/index/vv_life_icon_2_show.png"),
      title: "沃沃农贸",
      sub_title: "新型连锁智慧农贸市场领军品牌"
    }
    /*   {
                    image: require("@/assets/images/index/vv_life_icon_3.png"),
                    image_show: require("@/assets/images/index/vv_life_icon_3_show.png"),
                    title: "沃沃市集",
                    sub_title: "中国一站式的综合生活服务平台",
                }, */
  ],
  // 服务
  marketPosition: [
    {
      img: require("@/assets/images/index/service_object.png"),
      text: "服务对象",
      name: "周边居民"
    },
    {
      img: require("@/assets/images/index/service_content.png"),
      text: "服务内容",
      name: "以刚性消费为核心",
      namelist: "兼顾升级消费社区O2O"
    },
    {
      img: require("@/assets/images/index/service_aim.png"),
      text: "服务宗旨",
      name: "提供社区活动共享平台",
      namelist: "满足周边居民日常生活消费"
    }
  ]
};

const getters = {
  indexSwipers(state) {
    return state.indexSwipers;
  },
  wapSwipers(state) {
    return state.wapSwipers;
  },
  vvLife(state) {
    return state.vvLife;
  },
  marketPosition(state) {
    return state.marketPosition;
  }
};

const mutations = {
  setIndexState(state, { key, value }) {
    state[key] = value;
  }
};

const actions = {
  getIndexSwiper({ state, dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      index
        .indexSwiper()
        .then(res => {
          let code = res.data.code;
          if (code == 200) {
            commit("setIndexState", {
              key: "indexSwipers",
              value: res.data.data
            });
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getWapSwiper({ state, dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      index
        .wapSwiper()
        .then(res => {
          let code = res.data.code;
          if (code == 200) {
            commit("setIndexState", {
              key: "wapSwipers",
              value: res.data.data
            });
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js